import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { sizeType } from '../../interfaces/enumSizeType';
import { SegmentControlItemComponent } from './segment-control-item/segment-control-item.component';

@Component({
  selector: 'rr-segment-control',
  standalone: false,
  templateUrl: './segment-control.component.html',
  styleUrl: './segment-control.component.scss'
})
export class SegmentControlComponent implements AfterContentInit {
  @Input() size: string | undefined = sizeType.Medium;
  @Output() selectionChange = new EventEmitter<any>();

  @ContentChildren(SegmentControlItemComponent) scItems!: QueryList<SegmentControlItemComponent>;

  elementCounter: number = 0;
  activeIndex = 0;

  ngAfterContentInit() {
    this.scItems.forEach(item => item.size = this.size);
    this.updateActiveItem();
    this.setActiveItem(this.activeIndex, this.scItems.first.name)
    this.scItems.forEach((item, index) => {
      item.clicked.subscribe(() => this.setActiveItem(index, item.name))
    })
  }

  setActiveItem(index: number, name?: string) {
    this.activeIndex = index;
    this.updateActiveItem();
    this.selectionChange.emit({ index: index, name: name });
  }

  updateActiveItem() {
    this.scItems.forEach((item, index) => {
      item.isActive = index === this.activeIndex;
    })
    this.elementCounter = this.scItems.length;
  }

}
